import { useEffect, useState } from 'react'
import { useLoggedInUser } from '../../../app/hooks/useLoggedInUser'
import { useModalWithForm } from '../../../app/hooks/useModalWithForm'
import { useGetProductsQuery } from '../../../app/redux-fetch/apiProducts'
import { convertToLabelValue } from '../../../app/utils'
import { Option } from '../../../components/Forms/FormSelect'

interface UseProductModalProps {
  onSave: (data: any) => void
  customerId?: number
}

export const useProductModal = ({ onSave, customerId }: UseProductModalProps) => {
  const { tenantId } = useLoggedInUser()
  const [productOptions, setProductOptions] = useState<Option[]>([])

  const { data: products = [] } = useGetProductsQuery({ tenantId, customerId: customerId ?? -1 })

  useEffect(() => {
    setProductOptions(convertToLabelValue(products))
  }, [products])

  const { isModalOpen, openModal, closeModal, ModalComponent } = useModalWithForm({
    type: 'productModal',
    onSave: (createdProduct) => {
      onSave(createdProduct.data.id)
    },
    data: {
      customerId: customerId,
      enabled: true,
    },
  })

  return {
    productOptions,
    products,
    isModalOpen,
    openModal,
    closeModal,
    ModalComponent,
  }
}
